import { render, staticRenderFns } from "./ModifySearchBox.vue?vue&type=template&id=0b618a9d"
import script from "./ModifySearchBox.vue?vue&type=script&lang=js"
export * from "./ModifySearchBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports